var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "screen",
    class: {
      'show': !_vm.navbar.collapse
    },
    on: {
      "click": _vm.onScreenClick,
      "touch": _vm.onScreenClick,
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auth),
      expression: "auth"
    }],
    staticClass: "nav-container",
    class: {
      customer: !_vm.isStaff
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-2"
  }, [_c('img', {
    staticStyle: {
      "height": "28px",
      "margin": "10px 10px 10px 10px"
    },
    attrs: {
      "src": _vm.logoPath
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "navbar-brand",
    staticStyle: {
      "display": "inline-block",
      "width": "100%",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.page.title) + "\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-sm-2 col-xs-2"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "display": "block"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "24px",
      "height": "22px",
      "margin": "14px 15px"
    },
    attrs: {
      "src": _vm.menuBtn
    },
    on: {
      "click": _vm.onNavbarToggle
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    class: {
      'in': !_vm.navbar.collapse
    }
  }, [_c('div', {
    staticClass: "clear-fix"
  }), _vm._v(" "), (_vm.isStaff) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    on: {
      "click": _vm.onNavbarToggle
    }
  }, [_c('a', {
    staticClass: "text-center",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.toCreateOrder
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("新建订单")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.onNavbarToggle
    }
  }, [_c('a', {
    staticClass: "text-center",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.toOrderList
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("订单列表")])])])]) : _vm._e(), _vm._v(" "), (!_vm.isStaff) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    on: {
      "click": _vm.onNavbarToggle
    }
  }, [_c('a', {
    staticClass: "text-center",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.toMyOrderList
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("订单列表")])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear-fix"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auth),
      expression: "auth"
    }],
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "divider"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-7de64d4f","hasScoped":false}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 247
// module chunks = 0